import aboutData from './about';
import { CareerItem } from '@/data/types';

// Type definition for the CV data
export interface Language {
  name: string;
  level: string;
}

export interface CvData {
  title: string;
  exportButtonText: string;
  // Imported data from other modules
  careerTimeline: CareerItem[];
  // CV-specific data
  languages: Language[];
  interests: string[];
  header: {
    name: string;
    title: string;
    email: string;
    location: string;
    website: string;
    phone: string;
  };
}

// CV-specific data
const cvData: CvData = {
  title: "Curriculum Vitae",
  exportButtonText: "Export as PDF",
  // Import data from about.ts
  careerTimeline: aboutData.careerTimeline,
  // CV-specific data
  languages: [
    { name: "German", level: "Native" },
    { name: "English", level: "Fluent (C1)" },
    { name: "French", level: "Basic (A2)" }
  ],
  interests: [
    "Technology",
    "Games",
    "Cooking",
    "Family"
  ],
  header: {
    name: "Robin Wichmann",
    title: "Full-Stack Frontend Developer",
    email: "robwichmann@gmail.com",
    location: "Hauptstr. 58c, 21640 Bliedersdorf",
    website: "robinwichmann.com",
    phone: "0173 - 7126379"
  }
};

export default cvData;
